module.exports = __webpack_public_path__ + "img/cuttheprice.b7fcad63.png";